<form class="task-view-comments-time__form" (ngSubmit)="onSubmit()">
  <input
    class="task-view-comments-time__input"
    autoFocus
    [value]="hours()"
    (input)="onSetHour($event)"
    type="number"
    min="0"
    placeholder="час"
  />
  <input
    class="task-view-comments-time__input"
    [value]="minutes()"
    (input)="onSetMinute($event)"
    type="number"
    min="0"
    max="60"
    placeholder="мин"
  />
  <button type="submit" class="task-view-comments-time__send">
    <i class="icon-send"></i>
  </button>
</form>
